import React from 'react';
import { RefreshCw, Cpu, Code2, Lock, FileSearch, Cloud } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
export function IntegrationSection() {
  const {
    t
  } = useLanguage();
  const icons = [<RefreshCw className="w-4 h-4" data-id="element-197" />, <Cpu className="w-4 h-4" data-id="element-198" />, <Code2 className="w-4 h-4" data-id="element-199" />, <Lock className="w-4 h-4" data-id="element-200" />, <FileSearch className="w-4 h-4" data-id="element-201" />, <Cloud className="w-4 h-4" data-id="element-202" />];
  return <section id="technology" className="py-16 md:py-24 lg:py-40 bg-forest-50" data-id="element-203">
      <div className="container mx-auto px-4 sm:px-6 md:px-8" data-id="element-204">
        <div className="grid md:grid-cols-2 gap-10 lg:gap-20 items-center" data-id="element-205">
          {/* Left */}
          <div data-id="element-206">
            <p className="text-forest-500 font-semibold text-xs uppercase tracking-[0.2em] mb-6" data-id="element-207">
              {t.integration.label}
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-forest-900 tracking-tight leading-tight mb-8" data-id="element-208">
              {t.integration.headline}
            </h2>
            <p className="text-xl text-forest-600 font-light leading-relaxed mb-10" data-id="element-209">
              {t.integration.subtitle}
            </p>
            <a href="#contact" onClick={e => {
            e.preventDefault();
            window.location.hash = '#contact';
          }} className="text-brand-green font-semibold border-b border-brand-green pb-0.5 hover:text-forest-600 hover:border-forest-600 transition-colors inline-flex items-center gap-1.5" data-id="element-210">
              {t.integration.ctaLink}
            </a>
          </div>

          {/* Right: List */}
          <div className="space-y-4" data-id="element-211">
            {t.integration.items.map((item, idx) => <div key={idx} className="flex items-start gap-5 bg-white rounded-xl p-5 shadow-sm border border-forest-100 hover:shadow-md hover:border-forest-200 transition-all" data-id="element-212">
                <div className="w-10 h-10 bg-forest-50 rounded-lg border border-forest-100 flex items-center justify-center flex-shrink-0 text-brand-green" data-id="element-213">
                  {icons[idx]}
                </div>
                <div data-id="element-214">
                  <h3 className="font-semibold text-forest-900 text-base mb-1" data-id="element-215">
                    {item.title}
                  </h3>
                  <p className="text-sm text-forest-600 leading-relaxed" data-id="element-216">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}